import * as api from "../api/index";

import { GET_XL } from "./constants";

export const getXlData = () => async (dispatch) => {
  try {
    const { data } = await api.fetchXlData();

    dispatch({ type: GET_XL, payload: data });
  } catch (error) {
    console.log(error.response);
  }
};
